import type { CanvasClass, TemplateZone } from '../types/creative-template.types';
import { CANVAS_ASPECT_RATIOS, zoneColour } from '../helpers/creative-template.helpers';

interface ZonePreviewProps {
  canvasClass: CanvasClass;
  zones: Record<string, TemplateZone>;
  className?: string;
}

export function ZonePreview({ canvasClass, zones, className }: ZonePreviewProps) {
  const aspectRatio = CANVAS_ASPECT_RATIOS[canvasClass];

  return (
    <div className={className}>
      <div
        className="relative w-full overflow-hidden rounded-md border border-gray-400 bg-white"
        style={{ aspectRatio }}
      >
        {Object.entries(zones).map(([role, zone]) => (
          <div
            key={role}
            className="absolute box-border border border-black/30"
            style={{
              left: `${zone.x * 100}%`,
              top: `${zone.y * 100}%`,
              width: `${zone.w * 100}%`,
              height: `${zone.h * 100}%`,
              backgroundColor: zoneColour(role),
            }}
            title={`${role}: x=${zone.x}, y=${zone.y}, w=${zone.w}, h=${zone.h}`}
          >
            <span className="absolute left-0.5 top-0.5 truncate px-0.5 text-[10px] font-medium text-black/70">
              {role}
            </span>
          </div>
        ))}
      </div>
      <p className="mt-1 text-xs text-gray-500">
        {canvasClass} preview — zones are normalised fractions (0–1).
      </p>
    </div>
  );
}
